// extracted by mini-css-extract-plugin
module.exports = {"priceLevelDisplay":"PriceLevelDisplay_priceLevelDisplay__gCIF8","priceLevelDisplayDefault":"PriceLevelDisplay_priceLevelDisplayDefault__YyCgW"};